import { Body2, Headline4, Subtitle1 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import React from 'react'
import styled, { css } from 'styled-components'
import HighestRating from 'assets/about-tutoring/highest-rating.svg'

const Card = styled.div<{ isWhiteColor?: boolean; isScrollable?: boolean }>`
    height: auto;
    min-height: 10px;
    width: 390px;
    position: relative;
    padding: 15px;
    background-color: ${theme.colors.white};
    display: flex;
    flex-direction: column;
    border-radius: ${theme.borderRadius.normal};
    border: 3px solid ${theme.colors.accentBlue};
    box-shadow: 4px 4px 0px ${theme.colors.accentBlue};
    position: relative;
    gap: 10px;
    .credentials {
        display: flex;
        justify-content: space-between;
    }

    @media (max-width: 750px) {
        width: 100%;
        min-height: 100px;
        height: auto;
        ${({ isScrollable }) =>
            isScrollable
                ? css`
                      width: 300px;
                      min-height: 140px;
                  `
                : ''}
    }
`

const Rating = styled(HighestRating)`
    position: relative;
    right: 5px;
`

interface Props {
    text: string
    user: string
    isWhiteColor?: boolean
    isScrollable?: boolean
    className?: string
}

const ReviewCard = ({ text, user, isWhiteColor, isScrollable, className }: Props) => {
    return (
        <Card isWhiteColor={isWhiteColor} isScrollable={isScrollable} className={className}>
            <div className="credentials">
                <Rating />
                <Body2 color={theme.colors.body2Black} fontWeight={700}>
                    {user}
                </Body2>
            </div>
            <Headline4 fontSize={16} color={theme.colors.accentBlue} fontWeight={700} marginBottom={10}>
                {text}
            </Headline4>
        </Card>
    )
}

export default ReviewCard
